import { render, staticRenderFns } from "./xpss.vue?vue&type=template&id=0d5f9453&scoped=true&"
import script from "./xpss.vue?vue&type=script&lang=js&"
export * from "./xpss.vue?vue&type=script&lang=js&"
import style0 from "./xpss.vue?vue&type=style&index=0&id=0d5f9453&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f9453",
  null
  
)

export default component.exports